export class TaggingError extends Error {
  private readonly _data: unknown;

  constructor(data: unknown, message: string = 'General error.') {
    let errorMessageParts = ['Video tagging error.', message];
    let causingError: Error | undefined;

    if (data instanceof TaggingError) {
      errorMessageParts = [data.message];
      causingError = data;
    } else if (data instanceof Error) {
      errorMessageParts.push(data.message);
      causingError = data;
    } else if (typeof data === 'object') {
      try {
        errorMessageParts.push(JSON.stringify(data, null, 2));
      } catch {}
    } else if (typeof data === 'string') {
      errorMessageParts.push(data);
    }

    super(errorMessageParts.join(' '), { cause: causingError });
    this._data = data;
    this.name = this.constructor.name;
  }

  public get data() {
    return this._data;
  }
}
